export const TID = {
    nav: {
        logo: 'nav-logo',
        neighbourhoods: 'nav-neighbourhoods',
        affordability: 'nav-affordability',
        invest: 'nav-invest',
        quiz: 'nav-quiz',
        compare: 'nav-compare',
        insights: 'nav-insights',
        login: 'nav-login',
        dashboard: 'nav-dashboard',
        logout: 'nav-logout',
    },
    home: {
        heroCta: 'home-hero-cta',
        quizCta: 'home-quiz-cta',
        featuredList: 'home-featured-list',
        featuredCard: 'home-featured-card',
        newsletter: 'home-newsletter',
        newsletterInput: 'home-newsletter-input',
        newsletterSubmit: 'home-newsletter-submit',
    },
    search: {
        input: 'search-input',
        city: 'search-city',
        tag: 'search-tag',
        sort: 'search-sort',
        priceMin: 'search-price-min',
        priceMax: 'search-price-max',
        card: 'search-card',
        emptyState: 'search-empty',
    },
    detail: {
        hero: 'detail-hero',
        insightBtn: 'detail-insight-btn',
        insightText: 'detail-insight-text',
        favBtn: 'detail-fav-btn',
        compareBtn: 'detail-compare-btn',
        chatBtn: 'detail-chat-btn',
    },
    aff: {
        income: 'aff-income',
        down: 'aff-down',
        debts: 'aff-debts',
        rate: 'aff-rate',
        amort: 'aff-amort',
        calc: 'aff-calc',
        result: 'aff-result',
    },
    invest: {
        list: 'invest-list',
        card: 'invest-card',
    },
    quiz: {
        step: 'quiz-step',
        next: 'quiz-next',
        back: 'quiz-back',
        finish: 'quiz-finish',
        result: 'quiz-result',
        chip: 'quiz-chip',
        budget: 'quiz-budget',
        city: 'quiz-city',
    },
    compare: {
        add: 'compare-add',
        remove: 'compare-remove',
        table: 'compare-table',
    },
    chat: {
        toggle: 'chat-toggle',
        panel: 'chat-panel',
        input: 'chat-input',
        send: 'chat-send',
        message: 'chat-message',
        close: 'chat-close',
    },
    login: {
        google: 'login-google',
    },
    admin: {
        exportCsv: 'admin-export-csv',
        leadsTable: 'admin-leads-table',
        statCard: 'admin-stat-card',
    },
    insights: {
        card: 'insights-card',
        articleBody: 'insights-body',
    },
    watch: {
        panel: 'watch-panel',
        email: 'watch-email',
        threshold: 'watch-threshold',
        submit: 'watch-submit',
        confirmed: 'watch-confirmed',
        alertPill: 'watch-alert-pill',
        listItem: 'watch-list-item',
        remove: 'watch-remove',
    },
};

export default TID;
